// extracted by mini-css-extract-plugin
module.exports = {"tab-menu-wrapper":"SideTabMenu_tab-menu-wrapper__rTkGi","menu":"SideTabMenu_menu__rNg5d","menu-option":"SideTabMenu_menu-option__2jjZc","selected":"SideTabMenu_selected__34W6A"};